import { generateColumnId } from '../../../utils';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { QUARTILE_VIDEO_REPORT_ID } from './quartileVideoReportId';

const defaultColumns = [FIELDS.QUARTILE.field, FIELDS.IMPRESSIONS.field, FIELDS.QUARTILE_IMPRESSIONS_RATE.field].map(
    field => generateColumnId(QUARTILE_VIDEO_REPORT_ID, field)
);

const customColumns = {
    [REPORT_PRESET.PERFORMANCE]: [
        FIELDS.QUARTILE.field,
        FIELDS.IMPRESSIONS.field,
        FIELDS.QUARTILE_IMPRESSIONS_RATE.field,
    ].map(field => generateColumnId(QUARTILE_VIDEO_REPORT_ID, field)),
};

export { customColumns, defaultColumns };
